"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const cardGridStyle = theme => ({
    borderRadius: '10px',
    padding: '10px',
    backgroundColor: theme === 'light' ? '#FFFFFF' : '#272936'
});
const gridStyle = {
    height: '100%'
};
const footerStyle = {
    textAlign: 'right',
    marginTop: '10px'
};
const cellStyle = theme => ({
    textAlign: 'center',
    borderBottomWidth: 1,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
exports.default = {
    cellStyle,
    gridStyle,
    footerStyle,
    cardGridStyle,
};
